// extracted by extract-css-chunks-webpack-plugin
module.exports = {"paragraph":"css-1hGTU40OlW","paragraph__accordian":"css-1YlZ63M77S","paragraph__inlineCategoryContent":"css-30QK7_pbUa","paragraph__puff":"css-3u8Wj6x9Y7"};